import {useState} from 'react';

import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import CustomTextField from './CustomTextField';

const handleCreate = ({text, setText, strings, setStrings, onChange}) => e => {
  const newVal = [...strings, text];
  setStrings(newVal);
  onChange({target: {value: newVal}});
  setText('');
};

const handleRemove = ({string, strings, setStrings, onChange}) => e => {
  const newVal = strings.filter(s => s !== string);
  setStrings(newVal);
  onChange({target: {value: newVal}});
};

const MultiTextInput = props => {
  const [text, setText] = useState('');
  const [strings, setStrings] = useState(props.defaultValue || []);
  const {onChange} = props;
  const fieldProps = {
    ...props,
    value: text,
    onChange: e => setText(e.target.value),
    defaultValue: null
  };
  return (
    <Stack spacing={2}>
      <CustomTextField 
        {...fieldProps}
        buttonRight={
          <Button
            variant='primaryGradient'
            onClick={handleCreate({text, setText, strings, setStrings, onChange})}
          >
            Add
          </Button>
        }
      />
      <Grid container spacing={1}>
          {
            (strings || []).map(v =>
              <Grid item>
                <Chip
                  label={v}
                  variant='outlined'
                  onDelete={handleRemove({string: v, strings, setStrings, onChange})}
                />
              </Grid>
            )
          }
      </Grid>
    </Stack>
  );
};

export default MultiTextInput;
